import Skeleton from 'react-loading-skeleton';
import styles from './style/EnterpriseList.module.scss';

/**
 * 服務卡片的載入骨架：外框與 .mpCard 對齊，上排放開關 / 服務名 / 狀態徽章的占位。
 * expanded 依「送出的啟用狀態」決定形狀，讓骨架高度對齊重載完成後的卡片：
 *   - expanded=true（啟用）→ 多一段對應「使用期間 / 席位上限」欄位（＝展開後的樣子）
 *   - expanded=false（停用）→ 卡片收合，只留標題列一行
 * 用於：
 *   1. 管理方案彈窗整體載入中（一次顯示數張，預設 expanded）
 *   2. 單一卡片儲存變更後重新載入期間（該卡片暫時變骨架，依送出的 activate 決定形狀）
 */
const PlanCardSkeleton = ({ expanded = true }) => (
  <div className={styles.mpCard}>
    <div className={styles.mpCardTop}>
      <div className={styles.planCardLeft}>
        <Skeleton width={44} height={24} borderRadius={12} />
        <Skeleton width={140} height={20} />
        <Skeleton width={60} height={24} borderRadius={20} />
      </div>
    </div>
    {expanded && (
      <div style={{ marginTop: 18 }}>
        <Skeleton width={72} height={14} style={{ marginBottom: 8 }} />
        <Skeleton height={36} borderRadius={8} />
      </div>
    )}
  </div>
);

export default PlanCardSkeleton;
